import script from "./ExtendLicenseModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ExtendLicenseModal.vue?vue&type=script&setup=true&lang=js"

import "./ExtendLicenseModal.vue?vue&type=style&index=0&id=53605f4c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53605f4c"]])

export default __exports__